import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";

const NavigationBar: React.FC = () => {
  const linkClass = ({ isActive }: { isActive: boolean }) =>
    isActive ? "nav-link active fw-semibold" : "nav-link";

  return (
    <Navbar
      bg="dark"
      variant="dark"
      expand="lg"
      sticky="top"
      className="border-secondary"
    >
      <Container>
        <Navbar.Brand
          as={NavLink}
          to="/"
          className="d-flex align-items-center gap-2"
        >
          <img
            src="/favicon.ico"
            alt="Bartollini Pizza logo"
            width={30}
            height={30}
          />
          <span className="lh-1">
            <span className="fw-bold">Bartollini Pizza</span>
            <br />
            <small className="text-white-50">Wood-Fire Pizza</small>
          </span>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="navbar-nav" />
        <Navbar.Collapse id="navbar-nav">
          <Nav className="ms-auto">
            <NavLink to="/" className={linkClass} end>
              Home
            </NavLink>

            <NavLink to="/gallery" className={linkClass}>
              Gallery
            </NavLink>

            <NavLink to="/about" className={linkClass}>
              About Us
            </NavLink>

            <NavLink to="/contact" className={linkClass}>
              Contact
            </NavLink>

            <NavLink to="/book-event/" className={linkClass}>
              Book
            </NavLink>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;
